/**
 * `<ListSkeleton>` — the shared loading placeholder for list/table/grid bodies.
 *
 * Replaces the ad-hoc `Array.from({length}).map(() => <Skeleton .../>)` blocks
 * that every list page hand-rolled with slightly different heights/counts.
 * Defaults to a vertical stack; pass a grid `className` + `itemClassName` for
 * card grids.
 */

import { cn, Skeleton } from "@cometchat-ai/ui-dashboard";

interface ListSkeletonProps {
  /** Number of placeholder rows/cards. */
  rows?: number;
  /** Class for each placeholder (height/shape). */
  itemClassName?: string;
  /** Container class — override to a grid for card layouts. Default: vertical stack. */
  className?: string;
  "data-testid"?: string;
}

export function ListSkeleton({
  rows = 6,
  itemClassName = "h-12 w-full",
  className,
  ...rest
}: ListSkeletonProps) {
  return (
    <div className={cn("space-y-3", className)} data-testid={rest["data-testid"]}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className={itemClassName} />
      ))}
    </div>
  );
}
